module.exports = __webpack_public_path__ + "static/media/07.10caa191.png";